var $61c72f229aec4173$exports = {};
// Sudoku Generator - Creates puzzles with varying difficulty
if (window.__debug__) console.debug("SudokuGenerator loading...");
const $61c72f229aec4173$var$SudokuGenerator = {
    // Difficulty settings (number of clues to leave)
    difficulties: {
        easy: {
            min: 45,
            max: 50
        },
        medium: {
            min: 35,
            max: 40
        },
        hard: {
            min: 25,
            max: 30
        },
        expert: {
            min: 17,
            max: 22
        }
    },
    // Generate a new puzzle
    generate (difficulty = "easy") {
        if (window.__debug__) console.debug("Generating puzzle with difficulty:", difficulty);
        // Create a complete solved board
        const solution = this.createSolvedBoard();
        // Create puzzle by removing cells
        const puzzle = this.createPuzzle(solution, difficulty);
        if (window.__debug__) console.debug("Puzzle generated successfully");
        return {
            puzzle: puzzle,
            solution: solution
        };
    },
    // Create a complete solved board
    createSolvedBoard () {
        const board = Array(9).fill(0).map(()=>Array(9).fill(0));
        // Fill diagonal 3x3 boxes first (they don't conflict with each other)
        for(let box = 0; box < 9; box += 3)this.fillBox(board, box, box);
        window.SudokuSolver.solve(board);
        return board;
    },
    // Fill a 3x3 box with random numbers
    fillBox (board, row, col) {
        const numbers = this.shuffleArray([
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ]);
        let idx = 0;
        for(let i = 0; i < 3; i++)for(let j = 0; j < 3; j++)board[row + i][col + j] = numbers[idx++];
    },
    // Create puzzle by removing cells from solved board
    createPuzzle (solution, difficulty) {
        const puzzle = [
            ...solution.map((row)=>[
                    ...row
                ])
        ];
        const { min: min, max: max } = this.difficulties[difficulty];
        const clues = Math.floor(Math.random() * (max - min + 1)) + min;
        const cellsToRemove = 81 - clues;
        // Get all cell positions
        const positions = [];
        for(let i = 0; i < 9; i++)for(let j = 0; j < 9; j++)positions.push([
            i,
            j
        ]);
        const shuffledPositions = this.shuffleArray(positions);
        for(let i = 0; i < cellsToRemove && i < shuffledPositions.length; i++){
            const [row, col] = shuffledPositions[i];
            puzzle[row][col] = 0;
        }
        return puzzle;
    },
    // Shuffle array using Fisher-Yates algorithm
    shuffleArray (array) {
        const shuffled = [
            ...array
        ];
        for(let i = shuffled.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [
                shuffled[j],
                shuffled[i]
            ];
        }
        return shuffled;
    }
};
window.SudokuGenerator = $61c72f229aec4173$var$SudokuGenerator;
if (window.__debug__) console.debug("SudokuGenerator exported to window");


//# sourceMappingURL=repo.8d618788.js.map
